import React from 'react'
import Layout from '../src/components/layouts'
import ErrorPage from '../src/components/pages/Error'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'

const NotFoundPage = () => (
  <>
    <WithSeoOverrides noindex nofollow />
    <Layout statusCode={404} footerClassName="max-w-1400">
      <ErrorPage statusCode={404} />
    </Layout>
  </>
)

export default NotFoundPage
